import enLang from './entries/en_US'
import arLang from './entries/ar_EG'
import zhLang from './entries/zh_CN'
import frLang from './entries/fr_FR'
import jaLang from './entries/ja_JP'

const AppLocale = {
  en: enLang,
  ar: arLang,
  zh: zhLang,
  fr: frLang,
  ja: jaLang
}

export default AppLocale
